import { WEATHER_MAP_LAYOUT_ORIENTATIONS } from '../../../config/weatherMapLayout.config';
import { createWeatherMapPollingQueryOptions } from '../../../utils/weatherMapQuery.utils';

export const EARTHQUAKES_ROUTE = 'getEarthquakes';
export const EARTHQUAKES_REFRESH_INTERVAL_MINUTES = 3;
export const EARTHQUAKES_QUERY_OPTIONS = createWeatherMapPollingQueryOptions({
  refreshIntervalMinutes: EARTHQUAKES_REFRESH_INTERVAL_MINUTES,
});
export const EARTHQUAKES_DEFAULT_ZOOM = 5;
export const EARTHQUAKES_RADIUS_METERS_PER_MAGNITUDE = 25000;
export const EARTHQUAKES_PATH_OPTIONS = Object.freeze({
  color: '#dc3545',
  fillColor: '#ffc107',
  fillOpacity: 0.45,
  weight: 2,
});

export const EARTHQUAKES_SELECTED_PATH_OPTIONS = Object.freeze({
  ...EARTHQUAKES_PATH_OPTIONS,
  fillOpacity: 0.65,
  weight: 3,
});

export const EARTHQUAKES_PAGE_LAYOUT = Object.freeze({
  resizableOrientation: WEATHER_MAP_LAYOUT_ORIENTATIONS.horizontal,
  nonResizableOrientation: WEATHER_MAP_LAYOUT_ORIENTATIONS.vertical,
  mapDefaultSize: '66%',
  panelDefaultSize: '34%',
  mapMinSize: '320px',
  panelMinSize: '340px',
});
